// In-App Notifications API Module
import { API_ENDPOINTS } from "../../constants/apiEndpoints";
import api from "../axios";
import { handleApiResponse } from "../handleApiResponse";

export const getMyNotifications = (params?: {
  page?: number;
  limit?: number;
  onlyUnread?: boolean;
}) =>
  handleApiResponse(
    api.get(API_ENDPOINTS.NOTIFICATIONS.MY, { params })
  );

export const markNotificationRead = (id: string) =>
  handleApiResponse(api.patch(API_ENDPOINTS.NOTIFICATIONS.MARK_READ(id), {}));

export const markAllNotificationsRead = () =>
  handleApiResponse(api.patch(API_ENDPOINTS.NOTIFICATIONS.MARK_ALL_READ, {}));

export const deleteNotification = (id: string) =>
  handleApiResponse(api.delete(API_ENDPOINTS.NOTIFICATIONS.DELETE(id)));

export const getActiveAnnouncements = () =>
  handleApiResponse(api.get(API_ENDPOINTS.NOTIFICATIONS.ANNOUNCEMENTS));

// Admin
export const adminCreateAnnouncement = (dto: {
  title: string;
  body: string;
  targetRoles?: string[];
  pinned?: boolean;
  expiresAt?: string;
}) =>
  handleApiResponse(api.post(API_ENDPOINTS.NOTIFICATIONS.ADMIN_CREATE, dto));

export const adminPublishAnnouncement = (id: string) =>
  handleApiResponse(
    api.post(API_ENDPOINTS.NOTIFICATIONS.ADMIN_PUBLISH(id), {})
  );

export const adminUpdateAnnouncement = (
  id: string,
  dto: Partial<{
    title: string;
    body: string;
    targetRoles: string[];
    pinned: boolean;
    expiresAt: string;
  }>
) =>
  handleApiResponse(
    api.patch(API_ENDPOINTS.NOTIFICATIONS.ADMIN_UPDATE(id), dto)
  );

export const adminDeleteAnnouncement = (id: string) =>
  handleApiResponse(
    api.delete(API_ENDPOINTS.NOTIFICATIONS.ADMIN_DELETE(id))
  );
